import React from 'react';

export default function CVIcon({ className }) {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.67756 12.0004L13.4048 6.27317L7.67756 0.545898L6.69318 1.53027L10.7457 5.57005H0.25V6.9763H10.7457L6.69318 11.0289L7.67756 12.0004Z" fill="#4D4D4D" fill-opacity="0.9"/>
    </svg>
  );
}